<template>
  <v-container grid-list-md fluid v-if="finished">
    <div class="text-xs-center">
      <v-dialog v-model="dialog_dbk" width="500">
        <v-card>
          <v-toolbar color="primary">
            <v-toolbar-title class="white--text">Atenção</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark icon @click="dialog_dbk = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            O sistema encontrou algumas inconsistências durante o processo de geração das
            informações.
            <br />
            <br />
            Deseja prosseguir e gerar o arquivo DBK mesmo assim, ou prefere visualizar o arquivo de
            log para verificar as inconsistências encontradas?
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="downloadDBK">Gerar DBK</v-btn>
            <v-btn color="primary" flat @click="viewLOG">Visualizar Arquivo de Log</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-xs-center">
      <v-dialog v-model="dialog_log" width="500">
        <v-card>
          <v-toolbar color="primary">
            <v-toolbar-title class="white--text">Atenção</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark icon @click="dialog_log = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            O sistema identificou algumas inconsistências durante o processo de validação dos dados.
            <br />
            <br />
            Gostaria de visualizar o arquivo de log para verificar as inconsistências encontradas?
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="viewLOG">Visualizar Arquivo de Log</v-btn>
            <v-btn color="primary" flat @click="dialog_log = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="showDialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-checkbox
            :true-value="1"
            :false-value="0"
            v-model="report.sendEmail"
            label="Enviar o Relatório por e-mail ao final do processamento?"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="downloadItem">Confirmar</v-btn>
          <v-btn @click="showDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Index-->
    <v-layout v-if="!dialog" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="display-1">{{ formTitle }}</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field
          hide-details
          append-icon="search"
          label="Pesquisar"
          v-model="search"
          @keyup.native="keyupSearch"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :pagination.sync="pagination"
          hide-actions
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id_texto }}</td>
            <td>{{ props.item.sigla }}</td>
            <td>{{ props.item.razao_social }}</td>
            <td>{{ props.item.cpf | formatCpfCnpj }}</td>
            <td>{{ props.item.cidade ? props.item.cidade.id_texto : " " }}</td>
            <td>{{ props.item.endereco }}</td>
            <td>
              {{ props.item.responsavel ? props.item.responsavel.id_texto : " " }}
            </td>
            <td>
              <v-checkbox
                :disabled="!hasAccess(entity, 'enabled')"
                v-model="props.item.ativo"
                @change="toggleAtivo(props.item)"
              ></v-checkbox>
            </td>
            <td align="center">
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icon
                  class="mx-0"
                  @click="editItemProcess(props.item['id'])"
                  :disabled="!hasAccess(entity, 'update')"
                >
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icon
                  class="mx-0"
                  @click="deleteItem(props.item, props.item.id, true)"
                  :disabled="!hasAccess(entity, 'delete')"
                >
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
                <span>Excluir</span>
              </v-tooltip>

              <v-tooltip top v-if="entity == 'contribuinte'">
                <v-btn
                  slot="activator"
                  icon
                  class="mx-0"
                  @click="openDialogDBK(props.item, $event)"
                  :disabled="!hasAccess(entity, 'dbk')"
                >
                  <v-icon color="purple">share</v-icon>
                </v-btn>
                <span>Exportar DBK</span>
              </v-tooltip>
              <v-tooltip top v-else>
                <v-btn
                  slot="activator"
                  icon
                  class="mx-0"
                  @click="openDialogLog(props.item, $event)"
                  :disabled="!hasAccess(entity, 'dbk')"
                >
                  <v-icon color="blue">search</v-icon>
                </v-btn>
                <span>Validar DBK</span>
              </v-tooltip>

              <v-tooltip top>
                <v-btn slot="activator" icon class="mx-0" @click="resumoCaixa(props.item)">
                  <v-icon color="orange">library_books</v-icon>
                </v-btn>
                <span>Resumo do Caixa</span>
              </v-tooltip>

              <v-tooltip top>
                <v-menu slot="activator" offset-y>
                  <v-btn slot="activator" icon class="ml-2" title="Relatórios">
                    <v-icon color="indigo">library_books</v-icon>
                  </v-btn>
                  <v-list>
                    <!-- PDF -->
                    <v-list-tile @click="handleClick(props.item, 0)">
                      <v-list-tile-content>
                        <v-list-tile-title>Relatório Simples</v-list-tile-title>
                        <v-list-tile-sub-title>Apresentar apenas os bens rurais que sofreram alteração no ano-calendário</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <!-- Excel -->
                    <v-list-tile @click="handleClick(props.item, 1)">
                      <v-list-tile-content>
                        <v-list-tile-title>Relatório Completo</v-list-tile-title>
                        <v-list-tile-sub-title>Apresentar todos os bens rurais, independentemente de alteração no ano</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <!-- Último relatório gerado -->
                    <v-list-tile
                      v-if="props.item.has_report"
                      :href="`${api}reports/${props.item.id_texto}.pdf`"
                      target="_blank"
                    >
                      <v-list-tile-title>Visualizar o último Relatório gerado</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <span>Relatório para Declaração de Ajuste</span>
              </v-tooltip>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
        <div
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
            border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
            border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
          "
          class="v-datatable v-table theme--light"
        >
          <div class="v-datatable__actions">
            <div class="v-datatable__actions__select">
              Registros por página
              <v-select
                :items="[25, 50, 75, 100]"
                @change="changePage(pagination['current_page'])"
                v-model="pagination['rowsPerPage']"
                class="v-select__selection v-select__selection--comma"
              ></v-select>
              <!-- <input aria-label="Registros por página" readonly="readonly" type="text" autocomplete="on" aria-readonly="false"> -->
            </div>
            <div class="v-datatable__actions__range-controls">
              <div class="v-datatable__actions__pagination">
                {{ `${this.pagination.from} - ${this.pagination.to} de ${this.pagination.total}` }}
              </div>
              <button
                :disabled="pagination['current_page'] === 1"
                @click="changePage(pagination['current_page'] - 1)"
                type="button"
                :class="
                  pagination['current_page'] === 1
                    ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                    : 'v-btn v-btn--flat v-btn--icon theme--light'
                "
                aria-label="Previous page"
              >
                <div class="v-btn__content">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_left</i>
                </div>
              </button>
              <button
                :disabled="pagination['current_page'] === pagination.last_page"
                @click="changePage(pagination['current_page'] + 1)"
                type="button"
                :class="
                  pagination['current_page'] === pagination.last_page
                    ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                    : 'v-btn v-btn--flat v-btn--icon theme--light'
                "
                aria-label="Next page"
              >
                <div class="v-btn__content">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_right</i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <!--Create Edit-->
    <v-layout v-else wrap justify-center align-center>
      <v-flex xs12>
        <span class="display-1">{{ formTitle }}</span>
      </v-flex>

      <v-flex xs12 sm6 lg3>
        <v-text-field
          name="id_texto"
          :label="translate('table.' + entity + '.field.id_texto')"
          maxlength="67"
          counter
          data-vv-validate-on="blur"
          v-validate="'required'"
          required
          v-model="editedItem.id_texto"
          :error-messages="errors.collect('id_texto')"
          :data-vv-as="translate('table.' + entity + '.field.id_texto')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg3>
        <v-text-field
          name="sigla"
          :label="translate('table.' + entity + '.field.sigla')"
          maxlength="3"
          counter
          data-vv-validate-on="blur"
          v-validate="particular ? '' : 'required'"
          v-model="editedItem.sigla"
          :error-messages="errors.collect('sigla')"
          :data-vv-as="translate('table.' + entity + '.field.sigla')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg3>
        <v-text-field
          name="razao_social"
          :label="translate('table.' + entity + '.field.razao_social')"
          maxlength="67"
          counter
          data-vv-validate-on="blur"
          v-validate="'max:67'"
          required
          v-model="editedItem.razao_social"
          :error-messages="errors.collect('razao_social')"
          :data-vv-as="translate('table.' + entity + '.field.razao_social')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg3>
        <p-cpf-cnpj
          name="cpf"
          v-model="editedItem.cpf"
          v_validate="reqSeriauired"
          :data_vv_as="translate('table.' + entity + '.field.cpf')"
        ></p-cpf-cnpj>
      </v-flex>
      <v-flex v-if="!particular" xs12 md4>
        <v-autocomplete
          name="responsavel"
          :label="translate('table.' + entity + '.field.pessoa_id')"
          required
          v-model="editedItem.pessoa_id"
          :items="full_pessoas"
          item-text="id_texto"
          item-value="id"
          :error-messages="errors.collect('responsavel')"
          v-validate="'required'"
          :data-vv-as="translate('table.' + entity + '.field.pessoa_id')"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 :class="particular ? 'md6' : 'md4'">
        <v-text-field
          name="endereco"
          :label="translate('table.' + entity + '.field.endereco')"
          v-model="editedItem.endereco"
          maxlength="67"
          counter
          data-vv-validate-on="blur"
          v-validate="'required'"
          :error-messages="errors.collect('endereco')"
          :data-vv-as="translate('table.' + entity + '.field.endereco')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 :class="particular ? 'md6' : 'md4'">
        <v-autocomplete
          name="cidade_id"
          :label="translate('table.' + entity + '.field.cidade_id')"
          v-model="editedItem.cidade_id"
          :items="cidades"
          item-text="id_texto"
          item-value="id"
          data-vv-validate-on="blur"
          v-validate="'required'"
          :error-messages="errors.collect('cidade_id')"
          :data-vv-as="translate('table.' + entity + '.field.cidade_id')"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12>
        <v-switch
          :disabled="!hasAccess(entity, 'enabled')"
          name="ativo"
          :label="translate(`table.${entity}.field.ativo`)"
          v-model="editedItem.ativo"
        ></v-switch>
      </v-flex>
      <v-flex xs12>
        <v-tabs
          v-model="tab"
          color="green lighten-4"
          grow
          class="elevation-1"
          show-arrows
          v-if="view === 3"
        >
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            key="0"
            href="#0"
            @click="
              update_values(
                'condominio_pessoa',
                'condominio_pessoas',
                '?where=condominio_id=' + editedItem.id
              )
            "
            v-if="
              !editedItem.particular &&
              hasCondominioAccess('condominio_pessoa', 'read', editedItem.id)
            "
          >
            {{ this.translate("table.condominio_pessoa.title")[0] }}
          </v-tab>
          <v-tab
            key="1"
            href="#1"
            @click="update_values('condominio_transacao', '?where=condominio_id=' + editedItem.id)"
            v-if="
              !editedItem.particular &&
              hasCondominioAccess('condominio_transacao', 'read', editedItem.id)
            "
          >
            {{ this.translate("table.condominio_transacao.title")[0] }}
          </v-tab>
          <v-tab
            key="2"
            href="#2"
            v-if="hasCondominioAccess('condominio_bemdireito', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_bemdireito.title")[0] }}
          </v-tab>
          <v-tab
            key="3"
            href="#3"
            v-if="hasCondominioAccess('condominio_bemdireitorural', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_bemdireitorural.title")[0] }}
          </v-tab>
          <v-tab
            key="4"
            href="#4"
            v-if="hasCondominioAccess('condominio_dividaonus', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_dividaonus.title")[0] }}
          </v-tab>
          <v-tab
            key="5"
            href="#5"
            v-if="hasCondominioAccess('condominio_dividaonusrural', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_dividaonusrural.title")[0] }}
          </v-tab>
          <v-tab
            key="6"
            href="#6"
            v-if="hasCondominioAccess('condominio_rendimentorecebidopj', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_rendimentorecebidopj.title")[0] }}
          </v-tab>
          <v-tab
            key="7"
            href="#7"
            v-if="hasCondominioAccess('condominio_rendimentoisento', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_rendimentoisento.title")[0] }}
          </v-tab>
          <v-tab
            key="8"
            href="#8"
            v-if="hasCondominioAccess('condominio_rendimentotributacao', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_rendimentotributacao.title")[0] }}
          </v-tab>
          <v-tab
            key="9"
            href="#9"
            v-if="editedItem.particular && hasCondominioAccess('condominio_rendimentoacumuladamente', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_rendimentoacumuladamente.title")[0] }}
          </v-tab>
          <v-tab
            key="10"
            href="#10"
            v-if="hasCondominioAccess('condominio_pagamento', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_pagamento.title")[0] }}
          </v-tab>
          <v-tab
            key="11"
            href="#11"
            v-if="hasCondominioAccess('condominio_imovelexplorado', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_imovelexplorado.title")[0] }}
          </v-tab>
          <v-tab
            key="12"
            href="#12"
            v-if="hasCondominioAccess('condominio_movimentacaofinanceira', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_movimentacaofinanceira.title")[0] }}
          </v-tab>
          <v-tab
            key="13"
            href="#13"
            v-if="hasCondominioAccess('condominio_movimentacaorebanho', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_movimentacaorebanho.title")[0] }}
          </v-tab>
          <v-tab
            key="14"
            href="#14"
            v-if="hasCondominioAccess('condominio_controlecaixa', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_controlecaixa.title")[0] }}
          </v-tab>
          <v-tab
            key="15"
            href="#15"
            v-if="hasCondominioAccess('condominio_users', 'read', editedItem.id)"
          >
            {{ this.translate("table.condominio_users.title")[0] }}
          </v-tab>
          <v-tabs-items touchless v-model="tab" show-arrows>
            <v-tab-item
              key="0"
              value="0"
              v-if="
                !editedItem.particular &&
                hasCondominioAccess('condominio_pessoa', 'read', editedItem.id)
              "
            >
              <v-card v-if="tab == 0">
                <v-card-text>
                  <pessoa
                    :condominio_id="editedItem.id"
                    :values="editedItem.condominio_pessoas"
                    :quadro_societario="editedItem.condominio_quadrosocietario"
                    :pessoas="pessoas"
                    :conexoes="conexoes"
                  ></pessoa>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="1"
              value="1"
              v-if="
                !editedItem.particular &&
                hasCondominioAccess('condominio_transacao', 'read', editedItem.id)
              "
            >
              <v-card v-if="tab == 1">
                <v-card-text>
                  <transacao
                    :condominio_id="editedItem.id"
                    :values="editedItem.condominio_transacao"
                    :pessoas="editedItem.condominio_pessoas"
                  ></transacao>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="2"
              value="2"
              v-if="hasCondominioAccess('condominio_bemdireito', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 2">
                <v-card-text>
                  <bem-direito
                    :particular="particular"
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_bemdireito"
                    :cidades="cidades"
                    :paises="paises"
                    :dependente_items="dependente_items"
                    :temDependente="this.entity === 'contribuinte'"
                  ></bem-direito>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="3"
              value="3"
              v-if="hasCondominioAccess('condominio_bemdireitorural', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 3">
                <v-card-text>
                  <bem-direito-rural
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_bemdireitorural"
                    :cidades="cidades"
                    :paises="paises"
                  ></bem-direito-rural>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="4"
              value="4"
              v-if="hasCondominioAccess('condominio_dividaonus', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 4">
                <v-card-text>
                  <divida-onus
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_dividaonus"
                    :responsaveis="editedItem.condominio_pessoas"
                    :particular="particular"
                  ></divida-onus>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="5"
              value="5"
              v-if="hasCondominioAccess('condominio_dividaonusrural', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 5">
                <v-card-text>
                  <divida-onus-rural
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_dividaonusrural"
                    :responsaveis="editedItem.condominio_pessoas"
                  ></divida-onus-rural>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="6"
              value="6"
              v-if="hasCondominioAccess('condominio_rendimentorecebidopj', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 6">
                <v-card-text>
                  <rendimento-recebido-pj
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_rendimentorecebidopj"
                    :dependente_items="dependente_items"
                    :temDependente="this.entity === 'contribuinte'"
                    :particular="particular"
                  ></rendimento-recebido-pj>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="7"
              value="7"
              v-if="hasCondominioAccess('condominio_rendimentoisento', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 7">
                <v-card-text>
                  <rendimento-isento
                    :particular="particular"
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_rendimentoisento"
                    :dependente_items="dependente_items"
                    :temDependente="this.entity === 'contribuinte'"
                  ></rendimento-isento>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="8"
              value="8"
              v-if="hasCondominioAccess('condominio_rendimentotributacao', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 8">
                <v-card-text>
                  <rendimento-tributacao
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_rendimentotributacao"
                    :dependente_items="dependente_items"
                    :temDependente="this.entity === 'contribuinte'"
                  ></rendimento-tributacao>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="9"
              value="9"
              v-if="editedItem.particular && hasCondominioAccess('condominio_rendimentoacumuladamente', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 9">
                <v-card-text>
                  <rendimento-acumuladamente
                    :condominio_id="editedItem.id"
                    :anobase_id="$auth.user().anobase_id"
                    :values="editedItem.condominio_rendimentoacumuladamente"
                    :dependente_items="dependente_items"
                  ></rendimento-acumuladamente>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="10"
              value="10"
              v-if="hasCondominioAccess('condominio_pagamento', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 10">
                <v-card-text>
                  <pagamento
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_pagamento"
                    :dependente_items="dependente_items"
                    :temDependente="this.entity === 'contribuinte'"
                  ></pagamento>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="11"
              value="11"
              v-if="hasCondominioAccess('condominio_imovelexplorado', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 11">
                <v-card-text>
                  <imovel-explorado
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                    :values="editedItem.condominio_imovelexplorado"
                  ></imovel-explorado>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="12"
              value="12"
              v-if="hasCondominioAccess('condominio_movimentacaofinanceira', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 12">
                <v-card-text>
                  <movimentacao-financeira :condominio_id="editedItem.id"></movimentacao-financeira>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="13"
              value="13"
              v-if="hasCondominioAccess('condominio_movimentacaorebanho', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 13">
                <v-card-text>
                  <movimentacao-rebanho
                    :condominio_id="editedItem.id"
                    :values="editedItem.condominio_movimentacaorebanho"
                  ></movimentacao-rebanho>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="14"
              value="14"
              v-if="hasCondominioAccess('condominio_controlecaixa', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 14">
                <v-card-text>
                  <controle-caixa
                    :condominio_id="editedItem.id"
                    :initials="editedItem.sigla"
                  ></controle-caixa>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="15"
              value="15"
              v-if="hasCondominioAccess('condominio_users', 'read', editedItem.id)"
            >
              <v-card v-if="tab == 15">
                <v-card-text>
                  <usuario
                    :condominio_id="editedItem.id"
                    :values="editedItem.condominio_users"
                    :users="users"
                    :acessos="acessos"
                  ></usuario>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>

    <v-btn
      v-if="view === 1 && particular == 0"
      color="primary"
      dark
      fab
      fixed
      bottom
      right
      @click="create"
      :disabled="!hasAccess(entity, 'create')"
    >
      <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
    </v-btn>

    <v-layout v-if="view !== 1 || particular === 1" class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-btn v-model="fab" slot="activator" fab color="primary" dark :disabled="saving" :loading="saving" @click="save()">
          <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
          <v-icon>{{ this.translate("system.button.save.icon") }}</v-icon>
        </v-btn>

        <v-tooltip left>
          <v-btn slot="activator" fab small color="secondary" :disabled="saving" :loading="saving" @click="saveNew()">
            <v-icon>{{ this.translate("system.button.save_new.icon") }}</v-icon>
          </v-btn>
          <span>{{ this.translate("system.button.save_new.title") }}</span>
        </v-tooltip>

        <v-tooltip left v-if="this.$auth.user().acesso_interno !== 'user'">
          <v-btn slot="activator" fab small color="accent" :disabled="saving" :loading="saving" @click="saveEdit()">
            <v-icon>{{ this.translate("system.button.save_manage.icon") }}</v-icon>
          </v-btn>
          <span>{{ this.translate("system.button.save_manage.title") }}</span>
        </v-tooltip>
      </v-speed-dial>

      <v-btn v-if="view === 3" color="primary" dark fab :disabled="saving" :loading="saving" @click="save()">
        <v-icon>{{ this.translate("system.button.done.icon") }}</v-icon>
      </v-btn>

      <v-btn fab small @click="close">
        <v-icon>{{ this.translate("system.button.close.icon") }}</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 10;
}

.v-tabs__wrapper--show-arrows {
  /* margin-left: 10px !important;
    margin-right: 10px !important; */
}

.v-tabs__item {
  /* padding: 4px 2px !important; */
}

.v-tabs__div {
  font-size: 14px;
  font-weight: 800;
  text-transform: none;
}
</style>

<script>
import crud from "./../../mixin/crud";
import acl from "./../../mixin/acl";
import Pessoa from "../details/Pessoa";
import BemDireito from "../details/BemDireito";
import BemDireitoRural from "../details/BemDireitoRural";
import DividaOnus from "../details/DividaOnus";
import DividaOnusRural from "../details/DividaOnusRural";
import ImovelExplorado from "../details/ImovelExplorado";
import Pagamento from "../details/Pagamento";
import RendimentoIsento from "../details/RendimentoIsento";
import RendimentoTributacao from "../details/RendimentoTributacao";
import RendimentoRecebidoPj from "../details/RendimentoRecebidoPj";
import MovimentacaoFinanceira from "../details/MovimentacaoFinanceira";
import MovimentacaoRebanho from "../details/MovimentacaoRebanho";
import Transacao from "../details/Transacao";
import Usuario from "../details/Usuario";
import ControleCaixa from "../details/ControleCaixa";
import RendimentoAcumuladamente from "../details/RendimentoAcumuladamente";
import PCpfCnpj from "../shared/PCpfCnpj";

export default {
  mixins: [crud, acl],
  components: {
    Pessoa,
    BemDireito,
    BemDireitoRural,
    DividaOnus,
    DividaOnusRural,
    ImovelExplorado,
    Pagamento,
    RendimentoIsento,
    RendimentoTributacao,
    RendimentoRecebidoPj,
    MovimentacaoFinanceira,
    MovimentacaoRebanho,
    Transacao,
    Usuario,
    ControleCaixa,
    RendimentoAcumuladamente,
    PCpfCnpj,
  },
  data: () => ({
    entity: "condominio",
    tab: null,
    fab: null,
    particular: false,
    pagination: { rowsPerPage: 25, sortBy: "id_texto", descending: false },
    page: 1,
    setKeyup: null,
    acessos: [],
    cidades: [],
    conexoes: [],
    paises: [],
    pessoas: [],
    users: [],
    cities: [],
    permissoes: [],
    dependente_items: [],
    finished: true,
    showDialog: false,
    report: {
      selectedItem: null,
      type: null,
      sendEmail: 0,
    },
    api: process.env.API,
    dialog_dbk: false,
    dialog_log: false,
    
    log_file: "",
    dbk_file: "",
  }),
  created: function () {
    this.editedItem.condominio_transacao = 0;
    this.editedItem = { user_id: this.$auth.user().user_id, cpf: "", ativo: true };
    this.defaultItem = { user_id: this.$auth.user().user_id, cpf: "", ativo: true };
    // this.pagination['rowsPerPage'] = 25
    // this.pagination['sortBy'] = 'id_texto'
    this.initialize();
    this.getComplementValues();
  },
  methods: {
    openDialogDBK(item, event) {
      this.$store.commit("loader/change_dialog", true);
      this.$http
        .get(`export/dbk`, {
          params: {
            condominio_id: item.id,
            is_contribuinte: true,
          },
        })
        .then((res) => {
          this.$store.commit("loader/change_dialog", false);
          this.log_file = res.body.log_file;
          this.dbk_file = res.body.dbk_file;
          if (this.log_file) this.dialog_dbk = true;
          else this.downloadDBK();
        })
        .catch((error) => {
          // console.log(error);
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text: error.body.message,
            color: "error",
            dialog: true,
          });
        });
    },
    openDialogLog(item, event) {
      this.$store.commit("loader/change_dialog", true);
      this.$http
        .get(`export/dbk`, {
          params: {
            condominio_id: item.id,
            is_contribuinte: false,
          },
        })
        .then((res) => {
          this.$store.commit("loader/change_dialog", false);
          this.log_file = res.body.log_file;
          this.dialog_log = true;
        })
        .catch((error) => {
          // console.log(error);
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text: error.body.message,
            color: "error",
            dialog: true,
          });
        });
    },
    viewLOG() {
      window.open(process.env.API + `validacoes/${this.log_file}`, "_blank");
      this.dialog = false;
    },
    downloadDBK() {
      window.open(process.env.API + `dbks/${this.dbk_file}`, "_blank");
      this.dialog = false;
    },
    initialize() {
      this.beforeInitialize();
      this.$store.commit("loader/change_dialog", true);
      let params = {
        search: this.search,
        page: this.pagination["current_page"] ? this.pagination["current_page"] : 1,
        perPage: this.pagination["rowsPerPage"] ? this.pagination["rowsPerPage"] : 25,
        desc: this.pagination["descending"] ? this.pagination["descending"] : false,
        sort: this.pagination["sortBy"] ? this.pagination["sortBy"] : "id_texto",
        particular: this.particular ? this.particular : 0,
      };
      this.$http.post(`api/paginate_condominio`, params).then(
        (res) => {
          this.items = res.body.data;
          Object.assign(this.pagination, {
            total: res.body.total,
            rowsPerPage: res.body.per_page,
            current_page: res.body.current_page,
            last_page: res.body.last_page,
            from: res.body.from,
            to: res.body.to,
          });
          this.$store.commit("loader/change_dialog", false);
        },
        (err) => {
          this.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar os dados.",
            color: "error",
            dialog: true,
          });
          this.$store.commit("loader/change_dialog", false);
        }
      );
    },
    beforeInitialize() {
      this.particular = this.$route.path === "/contribuinte";

      if (this.particular) {
        this.entity = "contribuinte";

        if (this.$route.params.pessoa) {
          this.finished = false;
          this.$store.commit("loader/change_dialog", true);
          const { id } = this.$route.params.pessoa;

          this.editedItem.pessoa_id = id;
          this.editedItem.particular = true;

          this.$http.post("api/" + this.entity, this.editedItem).then(
            (res) => {
              Object.assign(this.editedItem, JSON.parse(JSON.stringify(res.body.dados)));

              this.getDependentes(this.editedItem.pessoa_id);

              this.$auth.user().acessos_condominios.push(res.body.acesso_condominio);

              this.$store.commit("loader/change_dialog", false);

              this.view = 3;
              this.dialog = true;

              this.finished = true;
            },
            () => this.$store.commit("loader/change_dialog", false)
          );
        }
      }
    },
    keyupSearch() {
      // caso o usuario fique 1 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup);
      this.setKeyup = setTimeout(() => {
        this.initialize();
      }, 1000);
    },
    changePage(page = 1) {
      this.pagination["current_page"] = page;
      this.initialize();
    },
    update_values(route, array = route, filter = "") {
      this.$store.commit("loader/change_dialog", true);

      this.$http.get(`api/${route}${filter}`).then((res) => {
        this.editedItem[array] = res.body.dados;
        this.$store.commit("loader/change_dialog", false);
      });
    },
    getDependentes(pessoa_id) {
      // Antes de editar verifica se é contribuinte para já buscar os dependentes que são usados nas abas
      if (this.entity === "contribuinte") {
        this.$http.get(`api/pessoa_dependente?where=pessoa_id=${pessoa_id}`).then(
          (res) => {
            this.dependente_items = res.body.dados;
            this.$store.commit("loader/change_dialog", false);
          },
          (err) => {
            this.$store.commit("snackbar/change_values", {
              text: "Não foi possível carregar os dependentes.",
              color: "error",
              dialog: true,
            });
            this.$store.commit("loader/change_dialog", false);
          }
        );
      }
    },
    editItemProcess(item_id) {
      this.$store.commit("loader/change_dialog", true);
      this.$http.get(`api/condominio/${item_id}`).then(
        (res) => {
          this.editItem(res.body);
          this.$store.commit("loader/change_dialog", false);
        },
        (err) => {
          this.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar os dados.",
            color: "error",
            dialog: true,
          });
          this.$store.commit("loader/change_dialog", false);
        }
      );
    },
    beforeEdit(item) {
      this.getDependentes(item["pessoa_id"]);
    },
    getComplementValues() {
      this.$http.get(`api/get_complement_values`).then(
        (res) => {
          let resBody = res.body;
          // this.items = [...this.items, ...this.resBody.conexoes]
          this.pessoas = resBody["pessoas"];
          this.acessos = resBody["acessos"];
          this.cidades = resBody["cidades"];
          this.conexoes = resBody["conexoes"];
          this.full_pessoas = [...this.pessoas, ...this.conexoes];
          this.paises = resBody["paises"];
          this.users = resBody["users"];
          this.cidades.map(function (value) {
            value.id_texto = value.id_texto + " - " + value.uf;
          });
          this.editedIndex = this.items.findIndex((x) => x.id === this.editedItem.id); // Necessário para atualizar o datatable após uma edição de contribuinte vinda da tela de pessoa
          this.$store.commit("loader/change_dialog", false);
        },
        (err) => {
          this.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar os valores complementares.",
            color: "error",
            dialog: true,
          });
          this.$store.commit("loader/change_dialog", false);
        }
      );
    },
    afterCreate(res) {
      if (this.particular && res.body.acesso_condominio) {
        this.$auth.user().acessos_condominios.push(res.body.acesso_condominio);
      }
    },
    handleClick(selectedItem, type) {
      this.report.selectedItem = selectedItem;
      this.report.type = type;
      this.showDialog = true;
    },
    downloadItem() {
      if (!this.report.sendEmail) this.$store.commit("loader/change_dialog", true);
      else {
        this.showDialog = false;

        this.$store.commit("snackbar/change_values", {
          text: "O relatório solicitado está sendo gerado e será enviado para seu e-mail assim que finalizado.",
          color: "info",
          dialog: true,
          timeout: 5000,
        });
      }

      this.$http
        .get(
          `report/declaracao_ajuste/${this.report.selectedItem.id}/1/${this.report.type}/${+this
            .particular}/${this.report.sendEmail}`
        )
        .then(
          (res) => {
            let { pdfname } = res.data;
            window.open(process.env.API + `reports/${pdfname}`, "_blank");

            this.$store.commit("loader/change_dialog", false);

            if (this.report.sendEmail && "Notification" in window) {
              Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                  const notification = new Notification("Renderização concluído", {
                    body: "Seu relatório está pronto! Confira agora mesmo em seu e-mail.",
                    icon: "/static/img/logo.png",
                  });
                }
              });
            }

            this.report.sendEmail = 0;
          },
          (error) => {
            this.$store.commit("loader/change_dialog", false);
            this.$store.commit("snackbar/change_values", {
              text:
                error.body.message ||
                "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
              color: "error",
              dialog: true,
            });
          }
        );
    },
    resumoCaixa(item) {
      this.$store.commit("loader/change_dialog", true);
      this.$http.get(`report/resumo_caixa/${item.id}`).then(
        (res) => {
          console.log("res.data", res.data);
          let fileName = res.data;
          window.open(process.env.API + "reports/" + fileName, "_blank");
          this.$store.commit("loader/change_dialog", false);
        },
        () => this.$store.commit("loader/change_dialog", false)
      );
    },
    toggleAtivo(item) {
      this.$store.commit("loader/change_dialog", true);
      this.$http.put(`api/${this.entity}/${item.id}`, { ativo: item.ativo }).then(
        (res) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text: `Registro de ${
              this.translate("table." + this.entity + ".title")[0]
            } editado com sucesso!`,
            color: "success",
            dialog: true,
          });
        },
        (err) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text: `Não foi possível editar o registro de ${
              this.translate("table." + this.entity + ".title")[0]
            }, reporte o erro.`,
            color: "error",
            dialog: true,
          });
        }
      );
    },
  },
  watch: {
    pagination: {
      handler(a, b) {
        // caso tenha trocado a ordenação busca novamente
        if (a.descending !== b.descending || a.sortBy !== b.sortBy) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate(`table.${this.entity}.field.id_texto`),
          value: "id_texto",
        },
        {
          text: this.translate(`table.${this.entity}.field.sigla`),
          value: "sigla",
        },
        {
          text: this.translate(`table.${this.entity}.field.razao_social`),
          value: "razao_social",
        },
        {
          text: this.translate(`table.${this.entity}.field.cpf`),
          value: "cpf",
        },
        {
          text: this.translate(`table.${this.entity}.field.cidade_id`),
          value: "cidade.id_texto",
        },
        {
          text: this.translate(`table.${this.entity}.field.endereco`),
          value: "endereco",
        },
        {
          text: this.translate(`table.${this.entity}.field.pessoa_id`),
          value: "responsavel.id_texto",
        },
        {
          text: this.translate(`table.${this.entity}.field.ativo`),
          value: "ativo",
          align: "center",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "210px",
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/Condominio.vue